import React, { Fragment } from "react";
import Header from "../components/Header";
import Admin from "../components/Team/adminteam";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from '../components/SEO';

const AdminTeam = () => {
  return (
    <Fragment>
      <Header />
      <SEO/>
      <Admin />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default AdminTeam;
